// Prevenir que Klaviyo agregue fuentes personalizadas.
 const originalAppendChild = Node.prototype.appendChild;

Node.prototype.appendChild = function (node) {
     if (node.id === 'kl-custom-fonts'){ 
     console.log(">> prevented kl-custom-fonts from being injected.")  
     return node;
     }
     return originalAppendChild.call(this, node);
 };